module.exports = __webpack_public_path__ + "img/trash-fill.d3787598.svg";